(function () {
    'use strict';
    var controllerId = '4a_pcSupportoAdd';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', '$uibModal', 'datacontext', 'pcSupporto', 'corsoId', 'opInsert', 'sedi', 'aziende', fn_4a_pcSupportoAdd]);

    function fn_4a_pcSupportoAdd($scope, $uibModalInstance, modal, datacontext, pcSupporto, corsoId, opInsert, sedi, aziende) {
        //***
        $scope.sedi = sedi;
        $scope.aziende = aziende;

        if ($scope.sedi != null && $scope.sedi.length > 0) {
            $scope.sedi.forEach(function (item) {
                var tIndirizzo = '';
                var comune = '';
                if (item.TIndirizzoId > 0 && item.TIndirizzoId != 5 || item.ComuneId > 0) {
                    datacontext.tIndirizzo_get(item.TIndirizzoId).then(function (data) {
                        //console.info('tIndirizzo_get', item.TIndirizzoId, data);
                        if (data) {
                            tIndirizzo = data.Title + ' ';
                        }
                        datacontext.istat_comune_get(item.ComuneId).then(function (data) {
                            //console.info('istat_comune_get', item.ComuneId, data);
                            if (data) {
                                comune = ' - ' + data.Nome + ' (' + data.Provincia + ')';
                            }
                            item.Name = tIndirizzo + item.Indirizzo + ',' + item.Civico + comune;
                        });
                    });
                }
                else {
                    item.Name = item.Indirizzo + ',' + item.Civico;
                }
            });
        }

        if (pcSupporto) {
            $scope.record = jQuery.extend({}, pcSupporto); //Clona oggetto.
            $scope.Title = 'Modifica Supporto (ID: ' + $scope.record.Id + ')';
            
        }
        else {
            $scope.Title = 'Nuovo Supporto';
            $scope.record = {};
            $scope.record.Id = 0;
            $scope.record.CNDCorsoId = corsoId;
            $scope.record.OpInsert = opInsert;
            $scope.record.Deleted = false;
            $scope.record.iVersion = 1;
        }

        //Impostazioni per calendario dateTimePicker
        $scope.datepickers = {};
        $scope.today = function () {
            $scope.dt = new Date();
        };
        $scope.today();

        $scope.clear = function () {
            $scope.dt = null;
        };

        // Disable weekend selection
        $scope.disabled = function (date, mode) {
            //return (mode === 'day' && (date.getDay() === 0 || date.getDay() === 6));
        };

        $scope.toggleMin = function () {
            $scope.minDate = $scope.minDate ? null : new Date();
        };
        $scope.toggleMin();
        $scope.dateOptions = {
            formatYear: 'yyyy',
            formatMonth: 'MM',
            startingDay: 1
        };

        $scope.openCalendar = function ($event, iOpened) {
            console.log('openCalendar');
            $event.preventDefault();
            $event.stopPropagation();

            $scope.opened1 = false;
            if (iOpened == 1) {
                console.log('iOpened == 1');
                $scope.opened1 = true;
            }

        };

        $scope.clear = function ($event, iOpened) {
            console.log('clear');
            if (iOpened == 1) {
                $scope.record.NascData = '';
                $scope.changed = true;
            }

        };

        $scope.format = "dd/MM/yyyy";



        $scope.ok = function (isValid) {
            if (isValid) {
                var result = addItem($scope.record);
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function addItem(item) {
            return item;
        }

        

    }
})();